﻿import { CommWebResponseCode } from "../api/dtos";


const getCreditCardErrorMessage = (responseCode: CommWebResponseCode) => {
        switch(responseCode) {
        case CommWebResponseCode.Expired:
            return "Expired - Your credit card has expired. Contact your financial institution if you are unsure why you have received this message";
        case CommWebResponseCode.InsufficientFunds:
            return "Insufficient Funds - Contact your financial institution if you are unsure why you have received this message";
        case CommWebResponseCode.DeclinedCommWeb:
        case CommWebResponseCode.DeclinedBank:
            return "Payment not Successful - Please check your credit card number, expiry date and CCV number and try again";
        default:
            return "Payment not Successful - Your payment was not accepted, please try again or contact Breast Cancer Trials for support";
        
    }
}



export default getCreditCardErrorMessage;